module.exports = __webpack_public_path__ + "static/img/ajax_loading.d83212c.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ajax_loading.gif
// module id = MW/R
// module chunks = 23